import axios from 'axios';
import localeService from '../locale-service';

const MapsApiEndpoints = {
  getPlacesAutocomplete: async (data) => {
    const language = await localeService.get();
    return axios.get(`${data.baseUrl}place/autocomplete/json?input=${data.place}&language=${language}&key=${data.key}`)
      .then((response) => response.data);
  },
  getPlaceDetails: async (data) => {
    const language = await localeService.get();
    return axios.get(`${data.baseUrl}place/details/json?place_id=${data.placeId}&language=${language}&key=${data.key}`)
      .then((response) => response.data);
  },
};

export default MapsApiEndpoints;
